import { Map, List, Set } from 'immutable'
import {
  getMultiplePmUserNodeInfo,
  getPmUserNodeInfo,
} from 'services/user-node-info/actions'
import {
  getAuthIsLoggedIn,
} from 'services/auth'
import {
  SET_EVENT_VIDEO_IMPRESSED,
} from 'services/event-tracking/actions'
import {
  setMultipleVideos as setMultipleVideosAction,
  setVideo as setVideoAction,
  setVideoError as setVideoErrorAction,
  setVideoImpressionData as setVideoImpressionDataAction,
  setMultipleVideosProcessing as setMultipleVideosProcessingAction,
  GET_PM_MULTIPLE_VIDEOS,
  GET_PM_VIDEO,
} from './actions'
import {
  getMany as getManyVideos,
  get as getVideo,
} from '.'

/**
 * Get multiple videos and dispatch associated actions
 * @param {Object} options The options
 * @param {import('redux').Dispatch} options.dispatch Redux dispatch function
 * @param {Map} options.auth The auth state
 * @param {Number[]|List|Set} options.videoIds The video ids
 * @param {String} options.language The request language
 */
export async function getVideoMultiple (options = {}) {
  const { dispatch, auth = Map(), language } = options
  let { videoIds = [] } = options
  if (List.isList(videoIds) || Set.isSet(videoIds)) {
    videoIds = videoIds.toArray()
  }
  try {
    const pmVideos = await getManyVideos(videoIds, { auth, language })
    // Errors on individual videos are returned inside pmVideos
    // and handled by SET_PM_MULTIPLE_VIDEOS
    dispatch(setMultipleVideosAction(videoIds, language, pmVideos))
    if (getAuthIsLoggedIn(auth)) {
      dispatch(getMultiplePmUserNodeInfo(videoIds))
    }
  } catch (e) {
    // Do Nothing
    dispatch(setMultipleVideosProcessingAction(videoIds, language, false))
  }
}

/**
 * Get one video and dispatch associated actions
 * @param {Object} options The options
 * @param {import('redux').Dispatch} options.dispatch Redux dispatch function
 * @param {Map} options.auth The auth state
 * @param {Number} options.videoId The video id
 * @param {String} options.language The request language
 */
export async function getVideoSingle (options = {}) {
  const { dispatch, auth, videoId, language } = options
  try {
    const pmVideo = await getVideo(videoId, { auth, language })
    dispatch(setVideoAction(videoId, language, pmVideo))
    dispatch(getPmUserNodeInfo(pmVideo.id))
  } catch (e) {
    dispatch(setVideoErrorAction(videoId, language, e))
  }
}

async function handleVideoImpression (dispatch, actionPayload) {
  const { event, language } = actionPayload
  const videoId = event.getIn(['properties', 'contentId'])
  dispatch(setVideoImpressionDataAction(videoId, language.get(0)))
}

export default function middleware (store) {
  return next => (action) => {
    const { dispatch } = store
    const { auth = Map() } = store.getState()
    switch (action.type) {
      case GET_PM_MULTIPLE_VIDEOS: {
        const { videoIds, language } = action.payload
        getVideoMultiple({
          dispatch, auth, videoIds, language,
        })
        break
      }
      case GET_PM_VIDEO: {
        const { videoId, language } = action.payload
        getVideoSingle({
          dispatch, auth, videoId, language,
        })
        break
      }
      case SET_EVENT_VIDEO_IMPRESSED:
        handleVideoImpression(dispatch, action.payload)
        break
      default:
        break
    }
    next(action)
  }
}
